import axios from 'axios';
import _ from 'lodash';
import {checkoutProductLists, FreeshipProductsScrollList, CrossSaleProductsScrollList} from "./product_list";
import {loadLoginPopup} from "./customer";
import {rootUrl,paymentCheckTimeout} from "./config";
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import globalEvent from "./eventEmitter";
// import autoComplete from "@tarekraafat/autocomplete.js";
// import Bloodhound from "bloodhound-js";

var paymentCheckTime=null;
var pickupPoints = [];
var pickupPointsAutoComplete = null;
/*
var countries = new Bloodhound({
  datumTokenizer: Bloodhound.tokenizers.whitespace,
  queryTokenizer: Bloodhound.tokenizers.whitespace,
  cache: false,
  prefetch: `https://wexthuset.ntah.com.vn/checkout/prefetchDP?searchTerm=15155`,
  remote: `https://wexthuset.ntah.com.vn/checkout/prefetchDP?searchTerm=15155`,
});

// async
const pickupData = {
      src: async (query) => {
        try {
          // Fetch Data from external Source
          document.getElementById("pickup_Point_Input").setAttribute("placeholder", "Searching...");
          const source = await fetch(`https://wexthuset.ntah.com.vn/checkout/searchservpoint?searchTerm=${query}`);
          const res = await source.json();
          document.getElementById("pickup_Point_Input").setAttribute("placeholder", pickupPointsAutoComplete && pickupPointsAutoComplete.placeHolder);
          // Data is array of `Objects` | `Strings`
          const data = res.status?res.services:null;
          return data;
        } catch (error) {
          return error;
        }
      },
      // Data 'Object' key to be searched
      keys: ["name","city","postalCode","streetName","searchTerm"],
      filter: (list) => {
        // Filter duplicates
        // incase of multiple data keys usage
        console.log(list);
        const filteredResults = Array.from(new Set(list.map((value) => value.match))).map((food) => {
          return list.find((value) => value.match === food);
        });

        return filteredResults;
      },
};
*/
function klarnaSuspend(){
  /*
  if(window._klarnaCheckout && typeof(window._klarnaCheckout)==='function'){
    window._klarnaCheckout(function(api) {
      api.suspend();
    });
  }
  */
  if(window.scoApi && window.scoApi.setCheckoutEnabled && typeof(window.scoApi.setCheckoutEnabled)==='function'){
    window.scoApi.setCheckoutEnabled(false);
  }
}

function klarnaResume(){
  /*
  if(window._klarnaCheckout && typeof(window._klarnaCheckout)==='function'){
    window._klarnaCheckout(function(api) {
      api.resume();
    });
  }
  */
  if(window.scoApi && window.scoApi.setCheckoutEnabled && typeof(window.scoApi.setCheckoutEnabled)==='function'){
    window.scoApi.setCheckoutEnabled(true);
  }
}

function freezeUI() {
  $("div.checkout-basket").LoadingOverlay("show",{
    image: "",
    text: "",
    background: "rgba(255,255,255,0.3)",
    zIndex: 1003,
    fade: false
  });
}

function unFreezeUI(){
  $("div.checkout-basket").LoadingOverlay("hide",true);
}

function registerKlarnaEvents(){
  window._klarnaCheckout(function(api) {
    api.on({
      'load': function(data) {
        console.log("Load:", data);
      }
    });
    //------------------------------
    api.on({
      'user_interacted': function(data) {
        console.log("user_interacted:", data);
      }
    });
    //------------------------------
    api.on({
      'customer': function(data) {
        console.log("Customer:", data);
      }
    });
    //------------------------------
    api.on({
      'shipping_address_change': function(data) {
        console.log("shipping_address_change:", data);
      }
    });
    //------------------------------
    api.on({
      'redirect_initiated': function(data) {
        console.log("redirect_initiated:", data);
      }
    });
    //------------------------------
    api.on({
      'network_error': function(data) {
        console.log("network_error:", data);
      }
    });
    //------------------------------
    api.on({
      'load_confirmation': function(data) {
        console.log("load_confirmation:", data);
      }
    });
    //------------------------------
    api.on({
      'validation_callback': function(data, callback) {
        console.log("validation_callback:", data);
        callback({should_proceed: true,msg:"Test client validation!"});
      }
    });
  });
}

function bindCheckoutPaymentEvents(){
  $("button[name='btn_show_co']").on("click", function(e){
    showHideCo(this);
  });
  $("button[name='btn_show_dco']").on("click", function(e){
    showHidedCo(this);
  });

  $("input[name='is_delivery_addr']").on("change", function(e){
    if($(this).is(":checked")){
      $("div.delivery-address").removeClass("hide");
      $("input[name='del_first_name']").attr("required","true");
      $("input[name='del_last_name']").attr("required","true");
      $("input[name='del_address_1']").attr("required","true");
      $("input[name='del_postal_code']").attr("required","true");
      $("input[name='del_city']").attr("required","true");
      $("input[name='del_phone']").attr("required","true");
    } else {
      $("div.delivery-address").addClass("hide");
      $("input[name='del_first_name']").removeAttr("required");
      $("input[name='del_last_name']").removeAttr("required");
      $("input[name='del_address_1']").removeAttr("required");
      $("input[name='del_postal_code']").removeAttr("required");
      $("input[name='del_city']").removeAttr("required");
      $("input[name='del_phone']").removeAttr("required");
      $("div.delivery-address input").removeClass("error");
      $("div.delivery-address label.error").remove();
    }
  });
  if($("#klarna-checkout-container").length) registerKlarnaEvents();
  if($("form.payment-info-form").length){
    $("form.payment-info-form").validate({
      rules: {
        postal_code: {
          required: true,
          digits: true,
          minlength: 5
        },
        del_postal_code: {
          required: true,
          digits: true,
          minlength: 5
        }
      },
      messages: {
        first_name: $("input[name='first_name']").data("errmsg"),
        del_first_name: $("input[name='first_name']").data("errmsg"),
        last_name: $("input[name='last_name']").data("errmsg"),
        del_last_name: $("input[name='last_name']").data("errmsg"),
        address_1: $("input[name='address_1']").data("errmsg"),
        del_address_1: $("input[name='address_1']").data("errmsg"),
        postal_code: $("input[name='postal_code']").data("errmsg"),
        del_postal_code: $("input[name='postal_code']").data("errmsg"),
        city: $("input[name='city']").data("errmsg"),
        country_code: $("select[name='country_code']").data("errmsg"),
        del_city: $("input[name='city']").data("errmsg"),
        phone_fixed: $("input[name='phone_fixed']").data("errmsg"),
        del_phone_fixed: $("input[name='phone_fixed']").data("errmsg"),
        email_work: {
          required: $("input[name='email_work']").data("errmsg"),
          email: $("input[name='email_work']").data("errmsg")
        },
        email_confirm: {
          required: $("input[name='email_work']").data("errmsg"),
          email: $("input[name='email_work']").data("errmsg")
        }
      }
    });
  }
  $("button[name='btn_place_order']").on("click", function(e){
    placeOrder(this);
  });
}

function bindCheckoutBasketEvents(){
  $("button[name='co_remove_item']").on("click", function(e){
    removeItem($(this).closest("div.co-basket-row").data("pid"),this);
  });
  $("button[name='co_decrease_qty'],button[name='co_increase_qty']").on("click", function(e){
    changeQty($(this).closest("div.co-basket-row").data("pid"),$(this).val(),this);
  });
  $("input[name='co_qty']").on("change", function(e){
    changeQty($(this).closest("div.co-basket-row").data("pid"),$(this).val(),this);
  });
  $("button[name='co_wish_item']").on("click",function(evt){
    evt.stopPropagation();
    if($(this).hasClass("fav-remove")) removefromfv(this,$(this).closest("div.co-basket-row").data("pid"));
    else add2fv(this,$(this).closest("div.co-basket-row").data("pid"));
  });
}

function bindCheckoutBasketFooter(){
  $("button[name='discount_activate']").on("click", function(e){
    applyDiscount(this);
  });
  $("span.giftcard-item>i").on("click", function(e){
    removeGiftcard(this);
  });
  $("button[name='giftcard_activate']").on("click", function(e){
    applyGiftcard(this);
  });
  $("div.disc-applied>span>i,div.overlap-type-error>span>i").on("click", function(e){
    removeDiscount(this);
  });
  $("textarea[name='co_msg_text']").on("change", function(e){
    msgChanged(this);
  });
  $("input[name='discount_box']").on("click", function(e){
    $(this).closest("div.co-discount-giftcards").find("div.error").html("");
  });
}

function bindCheckoutShipmentEvents(){
  $("input[name='shipment_type']").on("change", function(e){
    changeShipment($(this).val(),this);
  });
  tippy('#checkout_page .climate-compensation', {
    content: $('#checkout_page .climate-compensation').data('tooltip-txt'),
    allowHTML: true,
    interactive: true,
  });
  tippy('#checkout_page div.shipment-wrapper span.shipment-title.addr-store', {
    content: $('#checkout_page div.shipment-wrapper span.shipment-title.addr-store').data('tooltip-txt'),
    allowHTML: true,
    interactive: true,
  });
}

function bindCheckoutServicePointEvent(){
  /*
  var elePickup = document.getElementById("pickup_Point_Input");
  if(elePickup.getAttribute("data-postalcode"))
    searchPickupPoints(elePickup.getAttribute("data-postalcode"));
  else if(elePickup.getAttribute("data-city"))
    searchPickupPoints(elePickup.getAttribute("data-city"));
  else pickupPoints=[];
  */
  $.typeahead({
    input: '.wexthuset-pickup-point',
    dynamic: true,
    delay: 500,
    maxItem: 20,
    searchOnFocus: true,
    cache: false,
    group: {
      template: "Närliggande utlämningsställen - {{query}}"
    },
    //dropdownFilter: "service points",
    template: function (query, item) {
      var color = "#ff1493";
      return '<span class="row">' +
             '<span class="name">{{name}}</span>' +
             '<span class="addr">{{streetNumber}} {{streetName}}, {{city}} ({{postalCode}})</span>' +
             '</span>';
    },
    emptyTemplate: "Närliggande utlämningsställen",
    templateValue: "{{name}}, {{postalCode}}-{{city}}",
    source: {
      services: {
          display: ["name","searchTerm","postalCode","city", "streetName"],
          ajax: function(query) {
            return {
              type: "GET",
              url: '/checkout/searchservpoint',
              data: {
                  searchTerm: '{{query}}'
              },
              path: 'services',
              callback: {
                  done: function (data, textStatus, jqXHR) {
                    //console.log(data);
                    // Perform operations on received data...
                    // IMPORTANT: data has to be returned if this callback is used
                    return data;
                  },
                  fail: function (jqXHR, textStatus, errorThrown) {},
                  always :function (data, textStatus, jqXHR) {},
                  then: function (jqXHR, textStatus) {}
              }
            }
          }
      }
    },
    callback: {
        onInit: function (node) {
            console.log('Typeahead Initiated on ',$(node).selector);
        },
        onReady: function (node) {
          console.log('Typeahead is ready on ',node);
          $(node).closest(".typeahead__container").addClass("cancel");
          //typeahead__container cancel result
        },
        onShowLayout: function (node, query) {
          console.log('Typeahead shows layout on ', node, " with query "+query);
        },
        onHideLayout: function (node, query) {
          console.log('Typeahead hide layout on ' , node, " with query "+query);
        },
        onSearch: function (node, query) {
          console.log('Typeahead searchs on ' , node, " with query "+query);
        },
        onResult (node, query, result, resultCount, resultCountPerGroup) {
          console.log('Typeahead results on ' , node, " with query "+query);
          console.log("Result: ", result, "Count: ", resultCount, "Countpergroup: ",resultCountPerGroup);
        },
        onClick: function (node, a, item, event) {
          console.log("Click: ",node, a,item,event);
        },
        onClickBefore: function (node, a, item, event) {
          console.log("Click Before: ",node, a,item,event);
        },
        onClickAfter: function (node, a, item, event) {
          console.log("Click After: ",node, a,item,event);
          let url=`${rootUrl}/checkout/changeservpoint`;
          axios({url:url,method:'POST',data:{serv_id:item.Id}}).then(function(res) {
            console.log(res.data);
            $(node).val(item.name);
            $(node).attr("disabled","disabled");
            $(node).attr("data-point-id",item.Id);
            $(node).attr("data-postal_code",item.postalCode);
            $(node).closest(".typeahead__field").find(".typeahead__selected button i.fa").removeClass("fa-close").addClass("fa-check");
          }).catch(function(err){
            console.log(err);
          });
        },
        onCancel: function (node, item, event) {
          console.log("Cancel Node: ",node);
          console.log("Cancel Item: ",item);
          console.log("Cancel Event: ",event);
          let url=`${rootUrl}/checkout/changeservpoint`;
          axios({url:url,method:'POST',data:{serv_id:0}}).then(function(res) {
            console.log(res.data);
            if(event && event.originalEvent && event.originalEvent.hasOwnProperty("type")){ // Click on cancel button
              $(node).val($(node).attr("data-postal_code"));
              $(node).removeAttr("disabled");
            }
            setTimeout(function() {
              if($(node).val()) $(node).closest(".typeahead__field").find(".typeahead__selected button i.fa").removeClass("fa-check").addClass("fa-close");
              else $(node).closest(".typeahead__field").find(".typeahead__selected button i.fa").addClass("fa-check").removeClass("fa-close");
              $(node).focus();
            }, 100)
            $(node).closest(".typeahead__container").removeClass("loading").addClass("cancel");
          }).catch(function(err){
            console.log(err);
          });
        },
    },
    debug: true
  });
}

function bindCheckoutEvents(){
  bindCheckoutBasketEvents();
  bindCheckoutBasketFooter();
  bindCheckoutShipmentEvents();
  bindCheckoutServicePointEvent();
  bindPaymentGatewayEvents();
  bindCheckoutPaymentEvents();
  checkoutProductLists();
  displayOutStockMsg();
  displayDiscountGiftcardMsg();
}


function scrollToTopAndShowMsgBox() {
  //document.getElementById("checkout_page").scrollIntoView(true);
  $("html, body").animate({ scrollTop: $("#checkout_page").position().top},600,function(){
    $("#wex_message_box").removeClass("hide");
  });
}

function scrollToDiscountGiftcardAreaAndShowMsgBox(msg) {
  $("html, body").animate({ scrollTop: $("div.co-discount-giftcards").position().top},600,function(){
    $("#wex_message_box span.msg-content").html(msg);
    $("#wex_message_box").removeClass("hide");
  });
}

function displaySwishErrorMsg(msg) {
  $("#wex_message_box span.msg-content").html(msg);
  $("#wex_message_box").removeClass("hide");
}


function displayOutStockMsg() {
  let ready4checkout=$("#checkout_page div.co-basket-rows").data("ready-for-checkout");
  let isShowMsg = $("#checkout_page input[name='showStockMsg']").val() == "show";
  if(!ready4checkout && isShowMsg) scrollToTopAndShowMsgBox();
}

function displayDiscountGiftcardMsg() {
  let validateStatus=$("#checkout_page div.co-basket-rows").data("validate-status");
  let discountGiftcardMsg = $("#checkout_page div.discount_giftcard_msg").html();
  if (!validateStatus && discountGiftcardMsg) scrollToDiscountGiftcardAreaAndShowMsgBox(discountGiftcardMsg)
}

function bindPaymentGatewayEvents() {
  $("button.gatewaylinks").on("click", function(e){
    changePaymentType($(this).data("payment-name"),this);
  });
}

function servicePointChanged(data){
  if(data && data.status && data.services && data.services.length) {
    $("select[name='service_point']").children('option:not(:first)').remove();
    $.each(data.services, function(key, value) {
      $("select[name='service_point']")
          .append($("<option></option>")
          .attr("value",value.servicePointId)
          .text(value.name+", "+value.deliveryAddress.streetName+" "+value.deliveryAddress.streetNumber+", "+value.deliveryAddress.city+" ("+value.deliveryAddress.postalCode+")"));
    });
  }
}

function bindCheckoutToUI(data) {
  var scrollPos=$("html").scrollTop();
  if(data && data.html){
    let $new=$(data.html);
    if($new.find("div.co-basket-rows").length){
      $("div.checkout-basket").find("div.co-basket-rows").replaceWith($new.find("div.co-basket-rows"));
      bindCheckoutBasketEvents();
    }
    if($new.find("div.co-basket-footer").length){
      $("div.checkout-basket").find("div.co-basket-footer").replaceWith($new.find("div.co-basket-footer"));
      bindCheckoutBasketFooter();
    }
    if($new.find("div.co-shipment-rows").length){
      $("div.checkout-basket").find("div.co-shipment-rows").replaceWith($new.find("div.co-shipment-rows"));
      bindCheckoutShipmentEvents();
    }
    if($new.find("div.delivery-points-info").length){
      if($("div.checkout-basket").find("div.delivery-points-info").length)
        $("div.checkout-basket").find("div.delivery-points-info").replaceWith($new.find("div.delivery-points-info"));
      else {
        $new.find("div.delivery-points-info").insertAfter($("#deliveryPoint"));
        $("#deliveryPoint").css({display: "none"});
      }
      bindCheckoutServicePointEvent();
    }else{
      $("div.checkout-basket").find("div.delivery-points-info").remove();
      $("#deliveryPoint").css({display: "none"});
    }
    $("div.checkout-basket").find("#products_crosssale").remove();
    if($new.find("#products_crosssale").length){
      $new.find("#products_crosssale").insertAfter($("div.checkout-basket div.co-basket-footer"));
      CrossSaleProductsScrollList();
    }
    $("div.checkout-basket").find("#products_freeship").remove();
    if($new.find("#products_freeship").length){
      $new.find("#products_freeship").insertAfter($("div.checkout-basket div.co-basket-footer"));
      FreeshipProductsScrollList();
    }
    if($new.find("div.payment-gateways").length){
      $("div.payment-gateways").replaceWith($new.find("div.payment-gateways"));
      bindPaymentGatewayEvents();
      bindCheckoutPaymentEvents();
    }else if($("div.payment-gateways").find("button[name='wex_gift']")){
      $("div.payment-gateways").find("button[name='wex_gift']").remove();
      var _b = data.model.basket , _n = _b.paymentInfo.name || "svea";
      var _e = $("div.payment-gateways").find("button[name='"+_n+"']");
      changePaymentType(_n,_e);
    }
  }
  $("html").scrollTop(scrollPos);
}

function add2fv(ele, pId){
  let url=`${rootUrl}/product/wishlist`;
  axios({url:url,method:'POST',data:{pId:pId}}).then(function(res) {
    if(res.data && res.data.status && res.data.html){
      $(ele).removeClass("fav-add").addClass("fav-remove");
      $(ele).find("i.fa").removeClass("fa-heart-o").addClass("fa-heart");
      $(ele).off("click");
      $(ele).on("click",function(evt){
        evt.stopPropagation();
        removefromfv(ele,$(ele).closest("div.co-basket-row").data("pid"));
      });
      $(`.prod-fv-list`).closest(".product-list-container").remove();
      $(res.data.html).insertBefore($(".wex-container .tp-slider.wh-widget"));
      $("div.prod-fv-list div.product-cell.fv-item button.close-btn").on("click",function(evt){
        evt.stopPropagation();
        removefromfv(this,$(this).data("pid"));
      });

      // alert event wish list changed number of items
      globalEvent.emit("wishlist-num-changed")
  }
  }).catch(function(err){
    console.log(err);
  });
}

function removefromfv(ele, pId){
  let url=`${rootUrl}/product/wishlist`;
  axios({url:url,method:'DELETE',data:{pId:pId}}).then(function(res) {
    if(res.data && res.data.status){
      $(`.prod-fv-list .product-cell.fv-item.prodid-${pId}`).remove();


      if($(ele).hasClass("fav-remove")){
        // remove button on basket row
        $(ele).removeClass("fav-remove").addClass("fav-add");
        $(ele).find("i.fa").removeClass("fa-heart").addClass("fa-heart-o");
        $(ele).off("click");
        $(ele).on("click",function(evt){
          evt.stopPropagation();
          add2fv(ele,$(ele).closest("div.co-basket-row").data("pid"));
        });
      } else if ($(ele).hasClass("close-btn")) {
        // on user click remove button from favorited product list
        // inactive favorite button on basket row
        const favButton = $(`.co-basket-row[data-pid='${pId}'] .remove-btn button[name='co_wish_item']`)

        favButton.removeClass("fav-remove").addClass("fav-add");
        favButton.find("i.fa").removeClass("fa-heart").addClass("fa-heart-o");
        favButton.off("click");
        favButton.on("click",function(evt){
          evt.stopPropagation();
          add2fv(favButton,favButton.closest("div.co-basket-row").data("pid"));
        });
      }

      if($(`.prod-fv-list .product-cell.fv-item`).length <= 0) {
        $(`.prod-fv-list`).closest(".product-list-container").remove();
      }

      // alert event wish list changed number of items
      globalEvent.emit("wishlist-num-changed")
    }
  }).catch(function(err){
    console.log(err);
  });
}

function msgChanged(ele) {
  let url=`${rootUrl}/checkout/msgchange`;
  axios({url:url,method:'POST',data:{msg: $(ele).val()}}).then(function(res) {
    console.log(res.data);
  }).catch(function(err){
    console.log(err);
  });
}

function removeDiscount(ele) {
  let url=`${rootUrl}/checkout/removediscount`;
  freezeUI();
  klarnaSuspend();
  let discount_code = $(ele).closest("span.discount-item").data("disc-code");
  axios({url:url,method:'POST',data:{discount_code: discount_code}}).then(function(res) {
    klarnaResume();
    unFreezeUI();
    if(res.data && res.data.html)  bindCheckoutToUI(res.data);
    else if(res.data && res.data.error) {
      $(ele).closest("div.co-discount-giftcards").find("div.error").html(res.data.error);
    }
  }).catch(function(err){
    console.log(err);
  });
}

function removeGiftcard(ele) {
  let url=`${rootUrl}/checkout/removegiftcard`;
  freezeUI();
  klarnaSuspend();
  let giftcard=$(ele).closest("span.giftcard-item").data("gc-code");
  axios({url:url,method:'POST',data:{giftcards: giftcard}}).then(function(res) {
    klarnaResume();
    unFreezeUI();
    if(res.data && res.data.html)  bindCheckoutToUI(res.data);
    else if(res.data && res.data.error) {
      $(ele).closest("div.co-discount-giftcards").find("div.error").html(res.data.error);
    }
  }).catch(function(err){
    console.log(err);
  });
}

function applyGiftcard(ele) {
  let url=`${rootUrl}/checkout/applygiftcard`;
  freezeUI();
  klarnaSuspend();
  axios({url:url,method:'POST',data:{giftcards: $("input[name='giftcard_box']").val(),basket_total: $("input[name='basket_total']").val()}}).then(function(res) {
    klarnaResume();
    unFreezeUI();
    if(res.data && res.data.html)  bindCheckoutToUI(res.data);
    else if(res.data && res.data.applyGC) {
      let errorMsg="";
      for(let k in res.data.applyGC) errorMsg+=errorMsg?" - "+res.data.applyGC[k].error:res.data.applyGC[k].error;
      $(ele).closest("div.co-input-group").find("div.error").html(errorMsg);
    }
  }).catch(function(err){
    console.log(err);
  });
}

function applyDiscount(ele) {
  let url=`${rootUrl}/checkout/applydiscount`;
  freezeUI();
  klarnaSuspend();
  $("input[name='discount_box']").closest("div.co-discount-giftcards").find("div.error").html("");
  axios({url:url,method:'POST',data:{discount_codes: $("input[name='discount_box']").val()}}).then(function(res) {
    klarnaResume();
    unFreezeUI();
    var errorTxt = $(ele).closest("div.co-input-group").find("div.error");
    if(res.data && res.data.html)  bindCheckoutToUI(res.data);
    else if (!res.data.status && res.data.validateResults) {
      for (var i in res.data.validateResults) {
        var validateRs = res.data.validateResults[i];
        if (validateRs.status) {
          // errorTxt.html(`${errorTxt.html()}<div class='discount-accepted'>${validateRs.discountCode} - <strong>Accepted${validateRs.appliedProducts?` for product(s) ${validateRs.appliedProducts} `:""}</strong></div>`);
        } else {
          switch (validateRs.exitCode) {
            case 110:
              loadDiscountEmailVerifyForm({discountCode: validateRs.discountCode});
              errorTxt.html(`${errorTxt.html()}<div>${validateRs.msg}</div>`);
              return;
            // case 109:
            //   loadLoginPopup();
            //   errorTxt.html(`${errorTxt.html()}<div>${validateRs.msg}</div>`);
            //   return;
            default:
              errorTxt.html(`${errorTxt.html()}<div>${validateRs.msg}</div>`);
              break;
          }
        }
      }
    }
    if(res.data && res.data.error && res.data.error.length) {
      errorTxt.html(res.data.error);
    }
  }).catch(function(err){
    console.log(err);
  });
}

function loadDiscountEmailVerifyForm(params) {
  let url = `${rootUrl}/basket/discountEmailVerificationForm?discountCode=${params.discountCode}`;
  axios({url:url,method:'GET'}).then(function(res) {
    if(res.data.status && res.data.html)  {
      $('body').append(res.data.html);
      $("div.discount-verification-popup").show();
      bindDiscountVerificationPopupToUI();
    }
  }).catch(function(err){
    console.log(err);
  });
}

function bindDiscountVerificationPopupToUI() {
  try {
    $(".discount-verification-popup button.cl-close-btn").on("click", function(evt) {
      evt.stopPropagation();
      $("div.discount-verification-popup").remove();
    })
    $(".discount-verification-popup button[name='btn_verify']").on("click", function() {
      var discountCode = $("div.discount-verification-popup strong[name='discountCode']").text();
      var customerEmail = $("input[name='verification_email']").val();
      var basketId = $("div.discount-verification-popup input[name='basket_id_value']").val();
      verifyDiscountEmail(basketId, discountCode, customerEmail);
    })
  } catch (e) {

  }
}

function verifyDiscountEmail(basketId, discountCode, customerEmail) {
  let url = `${rootUrl}/basket/discount/verify`;
  if (!discountCode) $("div.discount-verification-popup div.cl-body div.cl-error").html("Discount code is empty");
  if (!customerEmail) $("div.discount-verification-popup div.cl-body div.cl-error").html("Verification email is empty");
  if (discountCode && customerEmail) {
    let postData = {
      basketId: basketId,
      discountCodes: discountCode,
      customer: {
        customerEmail: customerEmail
      }
    }
    freezeUI();
    klarnaSuspend();
    axios({url: url, method: 'POST', data: postData}).then(function(res) {
      klarnaResume();
      unFreezeUI();
      if (!res.data.status) {
        var errors = [];
        for (var i in res.data.validateRs) {
          errors.push(res.data.validateRs[i].msg);
        }
        $("div.discount-verification-popup div.cl-body div.cl-error").html(errors);
      } else {
        $("div.discount-verification-popup").remove();
        $("div.coadd-row input[name='email_work']").val(customerEmail);
        $("button[name='discount_activate']").trigger("click");
      }
    })
  }
}

function add2basketfromco(ele, pId, from, price){
  let url=`${rootUrl}/checkout/add2basket`;
  freezeUI();
  klarnaSuspend();
  axios({url:url,method:'POST',data:{product_id:pId,qty:1,from:from}}).then(function(res) {
    klarnaResume();
    unFreezeUI();
    bindCheckoutToUI(res.data);
  }).catch(function(err){
    console.log(err);
  });
  if (window.dataLayer) window.dataLayer.push({'product_id': pId,'product_price': price,'currency': 'SEK','content_category': from,'event': 'wh_add_basket'});
}

function removeItem(pId, ele) {
  let url=`${rootUrl}/checkout/removeit`;
  freezeUI();
  klarnaSuspend();
  axios({url:url,method:'POST',data:{product_id:pId}}).then(function(res) {
    klarnaResume();
    unFreezeUI();
    bindCheckoutToUI(res.data);
  }).catch(function(err){
    console.log(err);
  });
}

function changeShipment(sm_type, ele) {
  let url=`${rootUrl}/checkout/changesm`
  freezeUI();
  klarnaSuspend();
  axios({url:url,method:'POST',data:{sm_type:sm_type}}).then(function(res) {
    klarnaResume();
    unFreezeUI();
    bindCheckoutToUI(res.data);
  }).catch(function(err){
    console.log(err);
  });
}

function searchServicePoint(city_postalCode, ele) {
  let url=`${rootUrl}/checkout/searchservpoint`;
  axios.get(url,{params:{city_postalCode:city_postalCode}}).then(function(res) {
    servicePointChanged(res.data);
  }).catch(function(err){
    console.log(err);
  });
}

function changeServicePoint(servId, ele) {
  let url=`${rootUrl}/checkout/changeservpoint`;
  axios({url:url,method:'POST',data:{serv_id:servId}}).then(function(res) {
    console.log(res.data);
    //servicePointChanged(res.data);
  }).catch(function(err){
    console.log(err);
  });
}

function changePaymentType(payment_name, ele) {
  let url=`${rootUrl}/checkout/changepayment`;
  klarnaSuspend();
  axios({url:url,method:'POST',data:{payment_name:payment_name}}).then(function(res) {
    klarnaResume();
    if(res && res.data && res.data.html){
      $("#currentGateway_info").empty().html(res.data.html);
      $("button.gatewaylinks").removeClass("active");
      $(ele).addClass("active");
      $("#currentGateway_info").attr("data-pmname",payment_name);
      bindCheckoutPaymentEvents();
    }
    /*
    if(payment_name == 'svea') {
      location.href = "/checkout";
    }
    */
  }).catch(function(err){
    console.log(err);
  });
}

function changeQty(pId, qty, ele) {
  let url=`${rootUrl}/checkout/changeqty`;
  freezeUI();
  klarnaSuspend();
  axios({url:url,method:'POST',data:{product_id:pId, qty: qty}}).then(function(res) {
    klarnaResume();
    unFreezeUI();
    bindCheckoutToUI(res.data);
  }).catch(function(err){
    console.log(err);
  });
}

function checkPaymentStatus(){
  let url=`${rootUrl}/checkout/checkpaymentstatus`;
  let data = {
    token: $("input[name='payment_token']").val()
  };
  showProgress($("form.payment-info-form").attr("name"));
  clearTimeout(paymentCheckTime);
  axios({url:url,method:'POST',data:data}).then(function(res) {
    const data = res.data;
    if(data && data.status == 'process') {
      paymentCheckTime=setTimeout(checkPaymentStatus,paymentCheckTimeout);
    }else if(data && data.status == 'complete') {
      hideProgress();
      location.href=`${rootUrl}/checkout/confirmation?pid=${data.id}&byPassCleanBasket=true`;
    }else {
      hideProgress();
      console.log(data);
    }
  }).catch(function(err){
    hideProgress();
    console.log(err);
  });
}

function showProgress(name){
  $("button[name='btn_place_order']").addClass("prevent-click");
  if(name == 'swish'){
    $("div.checkout-progress .progress-text").css({display: "none"});
    $("div.checkout-progress .progress-text-swish").css({display: "block"});
  }else{
    $("div.checkout-progress .progress-text").css({display: "block"});
    $("div.checkout-progress .progress-text-swish").css({display: "none"});
  }
  $("div.checkout-progress").show();
}

function hideProgress(){
  $("button[name='btn_place_order']").removeClass("prevent-click");
  $("div.checkout-progress").hide();
}

function showHideCo(ele){
  $(ele).addClass("prevent-click");
  $(ele).addClass("hide");
  $(ele).closest(".coadd-row").find(".mr-1").removeClass("mr-1");
  $("div.coadd-row.co-line").show();
}

function showHidedCo(ele){
  $(ele).addClass("prevent-click");
  $("div.coadd-row.dco-line").show();
  $(ele).addClass("hide");
  $(ele).closest(".coadd-row").find(".mr-1").removeClass("mr-1");
}


function openSwishApp(data) {
  let swishcb_url=`${rootUrl}/checkout/swishsamedevice?uuid=${data.uuid}&order_id=${data.order_id}`;
  let app_url=`swish://paymentrequest?token=${data.swishToken}&callbackurl=${swishcb_url}`;
  paymentCheckTime=setTimeout(checkPaymentStatus,paymentCheckTimeout);
  window.location.replace(app_url);
}

function placeOrder(ele){
  if($("form.payment-info-form").valid()){
    let canPayGc = $("#checkout_page .co-basket-rows").data("canco-wgiftcard");
    let pType=$("div#currentGateway_info").data("pmname");
    if(canPayGc && pType != "wex_gift"){
      displaySwishErrorMsg("Please select Giftcard for checkout.");
      return;
    }
    let basket_total = $("#checkout_page .co-basket-rows").data("basket-total");
    if(!canPayGc && pType == "wex_gift"){
      displaySwishErrorMsg("Please select other payment type for checkout.");
      return;
    }
    
    let is_ready4_checkout = $("#checkout_page .co-basket-rows").data("ready-for-checkout");
    if(is_ready4_checkout){
      const data=$("form.payment-info-form").serialize();
      let url=`${rootUrl}/checkout/placeorder`;
      showProgress("general");
      axios({url:url,method:'POST',data:data}).then(function(res) {
        let data = res.data;
        if(data.status && data.paymentError) {
          hideProgress();
          displaySwishErrorMsg(data.paymentError);
          return;
        }
      if(data.status && data.paymentInfo) {
          hideProgress();
          $("input[name='payment_token']").val(data.paymentInfo);
          checkPaymentStatus();
          return;
        }
        if(data.status && data.typeName == 'bankgiro') {
          hideProgress();
          if(data.uuid) {
            location.href=`${rootUrl}/checkout/confirmation?pid=${data.uuid}&byPassCleanBasket=true`;
            return;
          }
        }
        if(data.status && data.typeName == 'bankFI') {
          hideProgress();
          if(data.uuid) {
            location.href=`${rootUrl}/checkout/confirmation?pid=${data.uuid}&byPassCleanBasket=true`;
            return;
          }
        }
        if(data.status && data.typeName == 'wex_gift') {
          hideProgress();
          if(data.uuid) {
            location.href=`${rootUrl}/checkout/confirmation?pid=${data.uuid}&byPassCleanBasket=true`;
            return;
          }
        }
      }).catch(function(err){
        hideProgress();
        console.log(err);
      });
    }else scrollToTopAndShowMsgBox();
  }
}

//-----------------------------------------------
export {bindCheckoutEvents,add2basketfromco};
